// import Footer1 from '../../../assets/images/icons/footer1.svg'
// import Footer2 from '../../../assets/images/icons/footer2.svg'
// import footerstar from '../../../assets/images/icons/footerstar.svg'

const FooterGetInTouchStrip = () => (
  <div className="flex w-full flex-wrap items-center justify-center gap-5 md:gap-10 bg-[#744DFF] px-4 py-1 md:px-8">
     <div className="flex items-center gap-2 md:gap-5">
      {/* <img src={footerstar} alt="left1" className="w-6 md:w-10" /> */}
      {/* <img src={Footer2} alt="left2" className="w-6 md:w-10" /> */}
    </div>
    <h2 className="font-gilroy font-medium text-center text-2xl tracking-wide text-white md:text-3xl lg:text-4xl py-7">
    Get In Touch With Us
    </h2>
    <div className="flex items-center gap-2 md:gap-5">
      {/* <img src={footerstar} alt="right1" className="w-6 md:w-10" /> */}
      {/* <img src={Footer1} alt="right2" className="w-6 md:w-10" /> */}
    </div>
  </div>
);

export default FooterGetInTouchStrip;
